export default "__VITE_ASSET__q8p0$oFu__"